<template>
  <div class="ma-8">
    <span class="subtitle-1">Transactions</span>
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              ID
            </th>
            <th class="text-left">
              Local Tran ID
            </th>
            <th class="text-left">
              Date and Time (ET)
            </th>
            <th class="text-left">
              Site ID
            </th>
            <th class="text-left">
              Total Amount
            </th>
            <th
              v-if="transactionType=='Issuance'"
              class="text-left"
            >
              Reward Eligible Amount
            </th>
            <th
              v-else
              class="text-left"
            >
              CPG Redeemed
            </th>
            <th class="text-left">
              Type
            </th>
            <th />
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="transaction in transactions"
            :key="transaction.id"
          >
            <td>{{ transaction.id }}</td>
            <td>{{ transaction.localTransactionId }}</td>
            <td>{{ getDateTimeInET(transaction.dateTime) }}</td>
            <td>{{ transaction.siteId }}</td>
            <td>{{ transaction.totalAmount }}</td>
            <td v-if="transactionType=='Issuance'">
              {{ transaction.rewardEligibleAmount }}
            </td>
            <td v-else>
              {{ transaction.cpgRedeemed }}
            </td>
            <td>{{ transaction.type }}</td>
            <td>
              <a
                :href="getTransactionLink(transaction.id)"
                target="_blank"
                rel="noopener noreferrer"
              >View</a>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
  import dateUtils from '../util/dateUtils'

  export default {
    name: 'DetectedTransactionsTable',

    props: {
      transactions: Array,
      adminPortalUrl: String,
      transactionType: String,
    },

    methods: {
      getTransactionLink (transactionId) {
        return this.adminPortalUrl + 'transactionMgmt/transaction/view.do?transactionId=' + transactionId
      },
      getDateTimeInET (dateString) {
        return dateUtils.getDateTimeInET(dateString)
      },
    },
  }
</script>

<style scoped>

</style>
